<template>
  <div class="headershipmenttype row m-0 mb-4">
    <div class="headershipmenttype__col1 row m-0">
      <img :src="dataHeader.img" />
    </div>
    <div class="headershipmenttype__col2"
         :style="dataHeader.shipmentTotal || dataHeader.InfoShipment ? 'width:45%' : 'width:84%; border-radius: 0 3px 3px 0;'">
      <h1>{{dataHeader.shipmenttype}}</h1>
      <p>{{dataHeader.text}}</p>
    </div>
    <div v-if="dataHeader.shipmentTotal" class="headershipmenttype__col3 row m-0">
      <p>Total Shipment:<br><span>{{dataHeader.shipmentTotal}}</span></p>
    </div>
    <div v-if="dataHeader.InfoShipment" class="headershipmenttype__col3 row m-0"
        style="width: 40%">
      <div class="row m-0 w-100"
          v-for="(item, idx) in dataHeader.InfoShipment" :key="idx">
        <div class="col-md-8 font-weight-bold pl-0">{{item.title}}</div>
        <div class="col-md-0 pr-1">:</div>
        <div class="col-md p-0">{{item.value}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {name: 'header-shipment-type',
  props: {
    dataHeader: Object
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/components/HeaderShipmentType.vue